<div #dropdownRef="ngbDropdown" ngbDropdown class="dropdown" container="body" placement="bottom-right" autoClose="true">
  <div class="dropdown-toggle-container" ngbDropdownToggle>
    <div class="three-dot-icon">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>

  <div ngbDropdownMenu class="dropdown-menu-start arrow_box" aria-labelledby="dropdownMenuLink">
    <div class="col options">
      <span class="menu-arrow"></span>
      <div class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text" (click)="onEditVariant()">
        <i class="_500 fa fa-pencil fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
        <span class="ms-2 f-10 _700 text-uppercase">Edit</span>
      </div>
      <div class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text" (click)="onDuplicateVariant()">
        <img src="assets/svg/duplicate.svg" width="14" height="14" alt="Duplicate Icon" />
        <span class="ms-2 f-10 _700 text-uppercase">Duplicate</span>
      </div>
      <div class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text" (click)="onDeleteVariant()">
        <i class="_500 fa fa-trash fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
        <span class="ms-2 f-10 _700 text-uppercase">Delete</span>
      </div>
    </div>
  </div>
</div>
